const envHost = import.meta.env.MODE === "development" ? import.meta.env.VITE_HOST_DEV || window.location.host : window.location.host;

type SubDomain = "devsm" | "devcalmap" | "devsantamaria";
export function useWindowLocationHost() {
  const host = envHost;
  const subDomains: SubDomain[] = ["devsm", "devcalmap", "devsantamaria"];

  const hostParts = host.split(".");
  let subDomain: string | undefined = undefined;
  if (hostParts.length >= 2) {
    subDomain = hostParts[hostParts.length - 2];
    if (!subDomain || subDomain === "app") {
      subDomain = undefined;
    }
  }

  const matchedSubDomain = subDomains.find((sub) => host.startsWith(sub));
  if (matchedSubDomain) {
    return {
      windowLocationHost: `${matchedSubDomain}.nextcargo.app`,
      subDomain
    };
  }

  return {
    windowLocationHost: envHost,
    subDomain
  };
}

export function useWindowIsShippingCompanyPage() {
  const windowHost = envHost;

  return {
    isShippingCompanyPage: windowHost.includes("transportadoras")
  };
}
